module.exports = __webpack_public_path__ + "static/media/2.aca5dbcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/2.png
// module id = 872
// module chunks = 0